const toLocalDate = (dateStr) => {
    let localDateStr = "-";
    if (dateStr) {
        dateStr = dateStr.toString().replace('Z', '');
        if (/\d\d\.\d\d\.\d\d\d\d \d\d:\d\d:\d\d/.test(dateStr)) {
            if (dateStr == "01.01.0001 00:00:00")
                return "-";

            return dateStr;
        }
        else if (/\d\.\d\d\.\d\d\d\d \d\d:\d\d:\d\d/.test(dateStr)) {
            if (dateStr == "1.01.0001 00:00:00")
                return "-";

            return '0' + dateStr;
        }

        const splittedByTimeAndDate = dateStr.split('T');
        const splittedDate = splittedByTimeAndDate[0].split('-');
        const splittedTime = splittedByTimeAndDate[1].split('.')[0].split(':');

        localDateStr = `${splittedDate[2]}.${splittedDate[1]}.${splittedDate[0]} ${splittedTime[0]}:${splittedTime[1]}:${splittedTime[2]}`;
    }

    if (localDateStr == "01.01.2001 00:00:00" || localDateStr == "01.01.0001 00:00:00")
        localDateStr = "-";

    return localDateStr;
}

const parseDate = (dateInput) => {
    const parts = dateInput.match(/(\d+)/g);
    return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5], parts[6]);
}

const isFirstDateBefore = (firstDate: Date, secondDate: Date) => {
    return firstDate.getTime() < secondDate.getTime();
}

const hoursAfter = (currentDate: Date, hours: number) => {
    return currentDate.setHours(currentDate.getHours() + hours);
}
const minutesAfter = (currentDate: Date, minutes: number) => {
    return currentDate.setMinutes(currentDate.getMinutes() + minutes);
}
const secondsAfter = (currentDate: Date, seconds: number) => {
    return currentDate.setSeconds(currentDate.getSeconds() + seconds);
}
class DateHelper {
    public static getYear(date: Date): string {
        return date.getFullYear().toString()
    }
    public static getMonth(date: Date): string {
        let month = (date.getUTCMonth() + 1).toString()
        if (month.length === 1) {
            month = `0${month}`
        }
        return month
    }
    public static getDay(date: Date): string {
        let day = date.getUTCDay().toString();
        if (day.length === 1) {
            day = `0${day}`
        }
        return day
    }
    public static getHour(date: Date): string {
        let hour = date.getUTCHours().toString()
        if (hour.length === 1) {
            hour = `0${hour}`
        }
        return hour
    }
    public static getMinute(date: Date): string {
        let minutes = date.getUTCMinutes().toString()
        if (minutes.length === 1) {
            minutes = `0${minutes}`
        }
        return minutes
    }
    public static getSecond(date: Date): string {
        let seconds = date.getUTCSeconds().toString()
        if (seconds.length === 1) {
            seconds = `0${seconds}`
        }
        return seconds
    }
}

export { toLocalDate, parseDate, isFirstDateBefore, hoursAfter, minutesAfter, secondsAfter }